/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {useState} from 'react';
import {CardNumberElement, CardExpiryElement, CardCvcElement, useElements, useStripe} from '@stripe/react-stripe-js';
import {Modal, LargeButton, Loader, InputComponent, Label, TextWarning, InputCheckbox} from '../../../../components';
import {CardForm, CardWrapper, SetDefaultComponent, ContentActionModal} from './styles';
import {InputWrapper} from '../../../config/styles';
import {useInputValue} from '../../../../utils/hooks/useInputValue';
import {Admin, Utils} from '../../../../utils/api';
import {CardInfo} from './component';

const CardField = ({onChange}) => (
  <CardWrapper>
    <CardInfo Cardfield={CardNumberElement} label="CARD NUMBER" />
    <CardInfo Cardfield={CardExpiryElement} label="MM/YY" /> <CardInfo Cardfield={CardCvcElement} label="CVC" />
  </CardWrapper>
);

const CheckoutForm = ({handleModalFunction, refreshCards}: {handleModalFunction: Function; refreshCards: any}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const [defaultCard, useDefault] = useState(false);
  const nameInput = useInputValue('');
  const ADMIN = new Admin();
  const utils = new Utils();
  const validateInput = utils.GetValidationInputPattern();

  const handleSubmit = async event => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      console.error('Card not loaded');
      return;
    }

    if (!validatedFirstName()) {
      return;
    }
    setProcessing(true);
    const payload: any = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardNumberElement) || {token: ''},
      billing_details: {name: nameInput.value},
    });

    if (payload.error) {
      console.error(payload.error);
      setProcessing(false);
    } else {
      let data = {
        paymentMethod: {
          id: payload.paymentMethod.id,
          default: defaultCard,
        },
      };
      const response: any = await ADMIN.AddCard(data);
      if (response.status) {
        setProcessing(false);
        reset();
      } else {
        setProcessing(false);
      }
    }
  };

  const reset = () => {
    setProcessing(false);
    nameInput.HandleValue('');
    useDefault(false);
    refreshCards();
    handleModalFunction(false);
  };
  function HandleFocus(input: any) {
    input.HandleWarning('');
    input.HandleStatus('normal');
  }
  function validatedFirstName(): boolean {
    if (Number(nameInput.value.length) === 0 || !Boolean(validateInput.test(nameInput.value))) {
      nameInput.HandleWarning('Please enter a valid name');
      nameInput.HandleStatus('error');
      return false;
    } else {
      nameInput.HandleWarning('');
      nameInput.HandleStatus('normal');
      return true;
    }
  }

  return (
    <>
      <CardForm>
        <InputWrapper>
          <Label
            text="FULL NAME"
            color={'rgba(93,110,129,1);margin-top:0px;  letter-spacing: 0.66px;line-height: 25.2px;'}
            fontWeight={'600'}
            fontSize={'12px'}
          />

          <InputComponent animateWidth="100%" dynamicSearch={nameInput} HandleFocus={() => HandleFocus(nameInput)} />
          <TextWarning status={nameInput.status} message={nameInput.warningMessage} display={';font-size:14px;margin-top:0px'} />
        </InputWrapper>
        <CardField onChange />
        <SetDefaultComponent>
          <InputCheckbox checked={defaultCard} onClick={() => useDefault(!defaultCard)} /> <span>Set as default payment method.</span>
        </SetDefaultComponent>
      </CardForm>

      <hr style={{border: '0.5px solid rgba(186, 193, 201, 0.22)', margin: 0}} />
      {!processing ? (
        <ContentActionModal>
          <LargeButton
            callback={() => handleModalFunction(false)}
            rColor="white"
            title="CANCEL"
            fColor="#5D6C76"
            xMargin={'0 16px 0 0'}
            bradius="6px"
          />
          <LargeButton callback={handleSubmit} lColor="#006BE1" rColor="rgba(0,122,255,1)" icon="done" title="SAVE CARD" />
        </ContentActionModal>
      ) : (
        <Loader width="186px" height="50px" />
      )}
    </>
  );
};

export const CardModal = ({handleModalFunction, refreshCards}: {handleModalFunction: Function; refreshCards: any}) => {
  return (
    <Modal title="Add a credit card" margin={'30px auto'}>
      <CheckoutForm handleModalFunction={handleModalFunction} refreshCards={refreshCards} />
    </Modal>
  );
};
